import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';
import { axiosPost, axiosGet } from "../react_axios/Axios"
import { bonafideDocName, fetchAuthReport, downloadReport } from "../utils/constants"
import Loader from "../utils/Loader";
import { goToVendorPage, openVendorDownloadCentre } from "../utils/vendorNavigation";

const drawerData = JSON.parse(sessionStorage.getItem('sessionVisitorDrawerData') || "[]")[0] || {};

const formattedAddress = JSON.parse(sessionStorage.getItem('FormatedAddress') || "null");

const formattedMob = JSON.parse(sessionStorage.getItem('FormatedMobNo') || "null");


// Some logins store the full name in FirstName, so appending LastName repeats the surname
const buildDisplayName = (firstName, lastName) => {
    const first = (firstName || '').trim();
    const last = (lastName || '').trim();
    if (!last) return first;
    if (!first) return last;
    const firstWords = first.split(/\s+/);
    if (firstWords[firstWords.length - 1].toLowerCase() === last.toLowerCase()) return first;
    return `${first} ${last}`;
}

const VendorDrawer = ({ head, userId, summaryPage }) => {
    const activePage = summaryPage || sessionStorage.getItem("summaryPage");
    const history = useNavigate();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [address, setAddress] = useState([])

    //toggle model for logout.................................
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    const logout = () => {
        sessionStorage.clear()
        navigate('/')
    }
    useEffect(() => {
        loadScripts();
        // console.log("233",JSON.parse(sessionStorage.getItem('LoginAccesslist'))[0]['IsRead'])
        // setLoginAccesslist(JSON.parse(sessionStorage.getItem('LoginAccesslist')))
        setFirstName(JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName'] != null &&
            JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName'])
        setLastName(JSON.parse(sessionStorage.getItem('loginDataSS'))['LastName'] != null &&
            JSON.parse(sessionStorage.getItem('loginDataSS'))['LastName'])
    }, []);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });

    }

    const togglesidebar = () => {
        // document.getElementById('sidebarvis') .style.display = "block";
        //         var sidebarElement = document.getElementById('sidebarvis');
        // sidebarElement.style.display = 'block';
        // sidebarElement.style.left = '0px';
        var sidebarElement = document.getElementById('sidebarvis');

        if (sidebarElement.style.display === 'block') {
            // Sidebar is currently visible, so we want to hide it
            sidebarElement.style.display = 'none';
            sidebarElement.style.left = '-270px';
            // Remove any additional CSS styles that were applied
            //   sidebarElement.style.backgroundColor = '';
            //   sidebarElement.style.width = '';
            //   sidebarElement.style.padding = '';
            // Add more CSS styles to remove as needed
        } else {
            // Sidebar is currently hidden, so we want to show it
            sidebarElement.style.display = 'block';
            sidebarElement.style.left = '0px';
            // Add more CSS styles to apply as needed
        }
    }

    const onBonafiedDownloadClick = async () => {
        setIsLoading(true);
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ExhibitionID",
            "ParameterValue": sessionStorage.getItem('sessionExhibitionID'),
            "ParameterDataType": "int"
        }
        const mapdata2 = {
            "ParameterName": "@ExhRegistrationID",
            "ParameterValue": sessionStorage.getItem('ExhRegistrationIDSS'),
            "ParameterDataType": "int"
        }

        list.push(mapdata1);
        list.push(mapdata2);

        const mapData = {
            "report_name": bonafideDocName,
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        setIsLoading(false);
        if (res != null) {
            var url = `${downloadReport}?SessionIdentifier=${res}&Export=Yes`;
            const win = window.location.replace(url, '_blank');
            if (win != null) {
                win.focus();
            }
        }

    }

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
                <div className="modal-dialog custom_modal_dialog modal-dialog-centered" style={{ maxWidth: '350px' }}>
                    <div className="modal-content" style={{ borderRadius: '8px', border: 'none', overflow: 'hidden' }}>
                        {/* Header */}
                        <div style={{ backgroundColor: '#3cbba7', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h6 style={{ color: 'white', margin: 0, fontWeight: '600', fontSize: '15px' }}>Confirm Logout</h6>
                            <button onClick={e => toggleModal()} style={{ background: 'none', border: 'none', color: 'white', fontSize: '24px', lineHeight: '1', padding: 0, cursor: 'pointer' }}>&times;</button>
                        </div>

                        {/* Body */}
                        <div style={{ padding: '30px 24px', textAlign: 'center' }}>
                            {/* Icon */}
                            <div style={{ width: '56px', height: '56px', backgroundColor: 'rgba(60, 187, 167, 0.15)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto' }}>
                                <i className="fa fa-user-circle-o" style={{ color: '#3cbba7', fontSize: '28px' }}></i>
                            </div>

                            <h5 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '24px', fontSize: '16px' }}>Do you really want to logout?</h5>

                            {/* Buttons */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <button onClick={logout} className="btn" style={{ backgroundColor: '#3cbba7', color: 'white', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    Log Out
                                </button>
                                <button onClick={e => toggleModal()} className="btn" style={{ backgroundColor: '#9ca3af', color: 'white', border: 'none', fontWeight: '600', padding: '10px', borderRadius: '4px', width: '100%' }}>
                                    Cancel
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}

            <a className=" mobile-tog"
                onClick={(e) => togglesidebar(e)}
            ><i class="fa fa-th-large" aria-hidden="true"></i></a>
            <div className="app-sidebar ps" id='sidebarvis'>

                <div className="main-sidemenu corporate-sidebar">
                    <div className="slide-left disabled d-none" id="slide-left" />

                    <ul className="side-menu user-info p-0">

                        {/* USER NAME */}
                        <div className="user-section mb-2">
                            <h6 className="text-uppercase text-white fw-bold mb-2" style={{ padding: '0 12px' }}>
                                {buildDisplayName(firstName, lastName)} {firstName ? `(${firstName.charAt(0).toUpperCase()}${lastName ? lastName.charAt(0).toUpperCase() : ''})` : ''}
                            </h6>

                            <div className="" style={{ margin: '0 -8px' }}>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: activePage === 'VendorRegistrationAU' ? '4px solid white' : '4px solid transparent', backgroundColor: activePage === 'VendorRegistrationAU' ? 'rgba(255,255,255,0.1)' : 'transparent' }}
                                    onClick={() => goToVendorPage(navigate, 'VendorRegistrationAU')}>
                                    <i className="fa fa-user-circle-o me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Profile</span>
                                </div>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: activePage === 'VendorWorkOrderList' ? '4px solid white' : '4px solid transparent', backgroundColor: activePage === 'VendorWorkOrderList' ? 'rgba(255,255,255,0.1)' : 'transparent' }}
                                    onClick={() => goToVendorPage(navigate, 'VendorWorkOrderList')}>
                                    <i className="fa fa-clipboard me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Scope of Work</span>
                                </div>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: activePage === 'EntryPass' ? '4px solid white' : '4px solid transparent', backgroundColor: activePage === 'EntryPass' ? 'rgba(255,255,255,0.1)' : 'transparent' }}
                                    onClick={() => goToVendorPage(navigate, 'EntryPass')}>
                                    <i className="fa fa-id-badge me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Material Entry Pass</span>
                                </div>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: activePage === 'ExitPass' ? '4px solid white' : '4px solid transparent', backgroundColor: activePage === 'ExitPass' ? 'rgba(255,255,255,0.1)' : 'transparent' }}
                                    onClick={() => goToVendorPage(navigate, 'ExitPass')}>
                                    <i className="fa fa-sign-out me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Material Exit Pass</span>
                                </div>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: '4px solid transparent' }}
                                    onClick={() => openVendorDownloadCentre(navigate)}>
                                    <i className="fa fa-download me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Download Center</span>
                                </div>

                                <div style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.3)', margin: '8px 20px' }}></div>

                                <Link to="/Change_Password" className="text-white text-decoration-none d-flex align-items-center"
                                    style={{ padding: '12px 20px', borderLeft: '4px solid transparent' }}
                                    onClick={togglesidebar}>
                                    <i className="fa fa-lock me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Change Password</span>
                                </Link>
                                <div className="text-white d-flex align-items-center"
                                    style={{ padding: '12px 20px', cursor: 'pointer', borderLeft: '4px solid transparent' }}
                                    onClick={toggleModal}>
                                    <i className="fa fa-power-off me-3" style={{ fontSize: '18px' }}></i> <span style={{ fontSize: '15px' }}>Sign out</span>
                                </div>
                            </div>
                        </div>

                        {/* INTRO HEADER */}
                        <p className="text-light  mb-2 corporate-text">
                            {drawerData?.Header || ""}
                        </p>

                        {/* HEADER 2 */}
                        <p className="text-light mb-3 corporate-text">
                            <strong>{drawerData?.Header2 || ""}</strong>
                        </p>
                        {/* <p className='text-white'> All communications regarding India ITME 2026 should be sent at:</p>
                        <div className="address-block mb-3 pt-0">
                            {formattedAddress ? (
                                <p className="text-light corporate-text bottom-bor mb-0"><i class="ri-hotel-line"></i>
                                    {formattedAddress.map((line, idx) => (
                                        line ? <span key={idx}>{line}<br /></span> : null
                                    ))}
                                </p>
                            ) : (
                                <p className="text-light corporate-text bottom-bor mb-0">

                                    <i class="ri-hotel-line icon-color"></i> <strong> India ITME Society</strong><br />
                                    1210-1212, Dalamal Tower,<br />
                                    A Wing, 12th Floor,<br />
                                    Plot No. 211, Nariman Point,
                                    Mumbai - 400021
                                </p>
                            )}

                            <p className="text-light corporate-text bottom-bor mb-0">
                                <i className="fa fa-phone" style={{ color: "#fff" }}></i> &nbsp;
                                {drawerData?.Phone || "+91 - 22 4972 4603"}
                            </p>

                            <div className="mb-3 text-white bottom-bor">
                                <i className="fa fa-mobile" style={{ fontSize: "18px", color: "#fff" }}></i> &nbsp;

                                {formattedMob ? (
                                    <p className="text-light corporate-text bottom-bor mb-0">
                                        {formattedMob.map((m, i) => (
                                            m ? <span key={i}>{m}<br /></span> : null
                                        ))}
                                    </p>
                                ) : (
                                    "91-8010823774, 9820507570"
                                )}
                            </div>

                            <p className="text-light corporate-text mb-0">
                                <i className="fa fa-envelope-o" style={{ color: "#fff" }}></i> &nbsp;
                                {drawerData?.Email || "itme@india-itme.com"}
                            </p>

                        </div> */}

                        <div style={{ height: '60px' }}></div>
                    </ul>
                </div>

                <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                    <div className="ps__thumb-x" tabIndex={0} style={{ left: 0, width: 0 }} />
                </div>
                <div className="ps__rail-y" style={{ top: 0, height: 625, right: 0 }}>
                    <div className="ps__thumb-y" tabIndex={0} style={{ top: 0, height: 573 }} />
                </div>
            </div>

        </>
    );
}
export default VendorDrawer;